import React, { VFC } from 'react';
import { IIconProps } from './types';

const CheckIcon: VFC<IIconProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.143 8.571 10.07 15.43l-3.214-3.117"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx={12} cy={12} r={10} stroke={color} strokeWidth={2} />
  </svg>
);

export default CheckIcon;
